import { createResource, RouterContext } from 'react-resource-router';

import { ForgeNavigationData } from 'src/types/navigation';
import { urls } from 'src/urls/projects';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const fetchForgeProjectNavigationData = async (
  workspaceSlug: string,
  projectKey: string
): Promise<ForgeNavigationData | null> => {
  const url = urls.api.internal.forgeMenuItems(workspaceSlug, projectKey);
  const response = await fetch(authRequest(url, { headers: jsonHeaders }));

  if (!response.ok) {
    throw new Error(
      `Error fetching forge project menu item data (${response.status}): ${response.statusText}`
    );
  }

  const {
    admin_menu_items,
    personal_settings_menu_items,
    workspace_menu_items,
  } = await response.json();

  return {
    forgeMenuItems: [],
    forgeAdminMenuItems: admin_menu_items,
    personalSettingsForgeMenuItems: personal_settings_menu_items,
    workspaceForgeMenuItems: workspace_menu_items,
  };
};

export const forgeProjectNavigationResource = createResource({
  type: 'FORGE_PROJECT_MENU_ITEMS',
  getKey: ({ match }: RouterContext) =>
    `forge-project-menu-items:${match.params.workspaceSlug}/${match.params.projectKey}`,
  maxAge: 1000 * 60 * 10,
  getData: ({ match }): Promise<ForgeNavigationData | null> => {
    const { workspaceSlug, projectKey } = match.params;

    if (!workspaceSlug || !projectKey) {
      throw new Error(
        'This resource can only be used on routes that contain a workspaceSlug and projectKey in the path'
      );
    }

    return fetchForgeProjectNavigationData(workspaceSlug, projectKey);
  },
});
